
import { Vue, Options, prop } from "vue-class-component";
import formatDate from "@/app/infrastructures/misc/common-library/FormatDate";

class Props {
  summary = prop<any>({
    default: () => ({}),
    type: Object
  });

  data = prop<any>({
    default: () => [],
    type: Array
  });
}

@Options({
  components: {}
})
class Table extends Vue.with(Props) {
  // computed
  get hangingData() {
    return this.data.filter(
      (item: any) => item.status?.toLowerCase() === "hanging"
    );
  }

  get nonHangingData() {
    return this.data.filter(
      (item: any) => item.status?.toLowerCase() === "non_hanging"
    );
  }
  formatDateToString(date: string) {
    return formatDate(date);
  }
}

export default Table;
